import axios from "axios";
import * as TokenService from "./token.service";

import { apiUrl } from "../consts";

const instance = axios.create({
    baseURL: apiUrl,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

const refreshUrl = "/auth/token/refresh/";

instance.interceptors.request.use(
    (config) => {
        const token = TokenService.getLocalAccessToken();
        if (token && config.url !== refreshUrl) {
            config.headers["Authorization"] = "Bearer " + token; // for Django spring Boot back-end
            //config.headers["x-access-token"] = token; // for Node.js Express back-end
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (
            err.response &&
            err.response.status === 401 &&
            originalConfig.url === refreshUrl
        ) {
            await TokenService.deleteSession();
            return;
        }
        if (originalConfig.url !== "auth/token/" && err.response) {
            // Access Token was expired
            if (err.response.status === 401 && !originalConfig._retry) {
                originalConfig._retry = true;

                try {
                    const rs = await instance.post(refreshUrl, {
                        refresh: TokenService.getLocalRefreshToken(),
                    });

                    const { access } = rs.data;
                    TokenService.updateLocalAccessToken(access);

                    return instance(originalConfig);
                } catch (_error) {
                    TokenService.deleteSession();
                    return Promise.reject(_error);
                }
            }
        }
        return Promise.reject(err);
    }
);

export default instance;
